import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Reaching",
    text: "Reaching those seeking hope. We go beyond our walls into Presidential Hills and the city of Jackson to share the love of Christ with the lost.",
  },
  {
    num: "02",
    title: "Teaching",
    text: "Teaching practical applications of God's Word. We equip believers with truth that works in everyday life, not just on Sunday morning.",
  },
  {
    num: "03",
    title: "Empowering",
    text: "Empowering believers to live victoriously and disciple others. Every member becomes a minister, reaching others with the same victory they have found.",
  },
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-28 md:py-40">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-[#4169E1] mb-6">Who We Are</p>
          <h2 className="font-display font-bold uppercase tracking-tighter leading-none text-4xl sm:text-5xl md:text-6xl max-w-3xl">
            A place where victory becomes a way of life
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="mt-8 max-w-2xl">
          <p data-testid="about-mission" className="text-base md:text-lg text-zinc-400 leading-relaxed">
            Hyde Park Victory Church is dedicated to reaching those seeking hope, teaching practical
            applications of God's word, and empowering believers to live victoriously and disciple others.
          </p>
        </Reveal>

        <div className="mt-24 space-y-0 border-t border-white/10">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.1}>
              <div
                data-testid={`about-chapter-${c.num}`}
                className="group grid grid-cols-12 gap-6 items-start py-12 md:py-16 border-b border-white/10"
              >
                <div className="col-span-12 md:col-span-3">
                  <span className="font-display font-bold text-7xl md:text-8xl text-white/5 group-hover:text-[#4169E1]/20 transition-colors duration-500 leading-none">
                    {c.num}
                  </span>
                </div>
                <div className="col-span-12 md:col-span-3">
                  <h3 className="font-display font-semibold uppercase tracking-tight text-2xl sm:text-3xl group-hover:text-[#4169E1] transition-colors duration-500">
                    {c.title}
                  </h3>
                </div>
                <div className="col-span-12 md:col-span-6">
                  <p className="text-sm md:text-base text-zinc-400 leading-relaxed">{c.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
